export default "__VITE_ASSET__foSkZJ71__ 400w, __VITE_ASSET__DdugDbBy__ 800w, __VITE_ASSET__Bx2KvcXa__ 1024w";